var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn-alpha",class:{'btn-alpha--disabled': _vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('div',{staticClass:"btn-alpha__icon"},[_vm._t("append-icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }